import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LazyMotion, domAnimation } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import RouteScroll from "@/components/RouteScroll";
import { PageViewTracker } from "@/components/Seo";

const Article = lazy(() => import("@/pages/Article"));
const Admin = lazy(() => import("@/pages/Admin"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const AuthCallback = lazy(() => import("@/pages/AuthCallback"));

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/guides/:slug" element={<Article />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LazyMotion features={domAnimation} strict>
      <SmoothScroll>
        <BrowserRouter>
          <RouteScroll />
          <PageViewTracker />
          <Suspense fallback={<div className="min-h-screen bg-[#F9F6F0]" />}>
            <AppRoutes />
          </Suspense>
        </BrowserRouter>
      </SmoothScroll>
      </LazyMotion>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
